import axios from 'axios';
import { publicApiUrl } from './ApiHost';
import authHeader from './AuthHeader';

class RegisterService {

  postClient(client) {
    return axios.post(publicApiUrl + 'clients', client);
  }

}

export default new RegisterService();